/** @format */

import {type Theme} from '@mui/material/styles';

/**
 * Returns the color token for a KPI value based on its execution status.
 *
 * Direction depends on `lowerIsBetter`:
 *   - false (higher-is-better, e.g. conversions, clicks):
 *       fact >= plan → good (green); fact < plan → bad (red)
 *   - true (lower-is-better, e.g. CPL, CPC, CPM, ДРР, budget):
 *       fact <= plan → good (green); fact > plan → bad (red)
 *
 * The same direction applies to both the fact column (factToDate vs planToDate)
 * and the forecast column (forecastAtEnd vs planForPeriod).
 *
 * Shared by KpiTable (summary view) and KpiCharts (dynamic view) so the two
 * representations of the same KPI never disagree on good/bad coloring.
 */
export const getValueColor =
  (fact: number, plan: number, lowerIsBetter: boolean) =>
  (theme: Theme): string | undefined => {
    const isGood = lowerIsBetter ? fact <= plan : fact >= plan;
    return isGood ? theme.palette.semantic_dark?.good.main : theme.palette.semantic_dark?.bad.main;
  };
